import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { from, of } from 'rxjs';
import { bufferCount, concatMap, delay, mergeMap } from 'rxjs/operators';

import { AlertService } from '../../services/alert.service';
import { LoginService } from '../../services/login.service';
import { PairingService } from '../../services/pairing.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'device',
    templateUrl: './device.component.html',
    styleUrls: ['./device.component.scss']
})
export class DeviceComponent implements OnInit, OnDestroy {

    serialNumber!: string;

    devices!: any[] | null;

    products!: any[];

    devicesByProduct: any[] | undefined;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private pairingService: PairingService,
        private loginService: LoginService
    ) {
    }

    ngOnInit() {
        this.route.paramMap.subscribe(
            (params) => {
                let serialNumber: string | null = params.get('serialNumber');
                if (serialNumber && serialNumber.trim().length > 0) {
                    this.serialNumber = serialNumber.trim();
                    this.devices = null;
                    this.getDevices();
                }
            }
        );
    }

    ngOnDestroy() {
    }

    updateDevicesByProduct(product: string) {
        if (this.devices && product) {
            this.devicesByProduct = this.devices.filter(device => device.product == product);
        }
    }

    searchDevices(serialNumber: string) {
        if (serialNumber && serialNumber.trim().length > 0) {
            this.router.navigate(['/devices', serialNumber.trim()]);
        }
    }

    getDevices() {
        this.progressIndicatorService.progress = true;
        this.pairingService.searchDevices(this.serialNumber).subscribe({
            next: (value: any) => {
                console.log('DeviceComponent.getDevices.pairingService.searchDevices.value', value);
                this.progressIndicatorService.progress = false;

                let devices: any[] = this.devices = value.devices.sort((a: any, b: any) => b.updateDatetime - a.updateDatetime);

                this.products = Array.from(new Set(devices.map(device => device.product)))
                    .map(product => ({ product: product, count: devices.filter(device => device.product == product).length }))
                    .sort((a, b) => b.count - a.count);

                if (this.products.length > 0) {
                    this.devicesByProduct = this.devices?.filter(device => device.product == this.products[0].product);
                }

                from(Array.from(new Set(devices.map(device => device.accountId))))
                    .pipe(
                        bufferCount(3),
                        concatMap(data => of(data).pipe(delay(333))),
                        mergeMap(data => data)
                    )
                    .subscribe(
                        (value: any) => {

                            const accountId: string = value;

                            console.log('DeviceComponent.getDevices.loginService.getAccountByAccountIdV2', accountId);
                            this.loginService.getAccountByAccountIdV2(accountId).subscribe({
                                next: (value: any) => {
                                    console.log('DeviceComponent.getDevices.loginService.getAccountByAccountIdV2.value', value);
                                    devices.filter(device => device.accountId == accountId)
                                        .forEach(device => device.account = value || {});
                                },
                                error: (error: any) => {
                                    console.log('DeviceComponent.getDevices.loginService.getAccountByAccountIdV2.error', error);
                                }
                            });

                            console.log('DeviceComponent.getDevices.loginService.getProfileByAccountIdV2', accountId);
                            this.loginService.getProfileByAccountIdV2(accountId).subscribe({
                                next: (value: any) => {
                                    console.log('DeviceComponent.getDevices.loginService.getProfileByAccountIdV2.value', value);
                                    devices.filter(device => device.accountId == accountId)
                                        .forEach(device => device.profile = value || {});
                                },
                                error: (error: any) => {
                                    console.log('DeviceComponent.getDevices.loginService.getProfileByAccountIdV2.error', error);
                                }
                            });
                        });
            },
            error: (error: any) => {
                console.log('DeviceComponent.getDevices.pairingService.searchDevices.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
